"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  asset: {
    image: {
      "class": 'image'
    },
    pdf: {
      "class": 'pdf-embed'
    },
    video: {
      "class": 'body-video-asset'
    }
  },
  embed: {
    "class": 'embed',
    'associated-press': {
      "class": 'associated-press-embed'
    },
    carousel: {
      "class": 'carousel-embed'
    },
    'city-spark': {
      "class": 'city-spark-embed'
    },
    facebook: {
      "class": 'facebook-embed'
    },
    form: {
      "class": 'form-embed'
    },
    'google-maps': {
      "class": 'google-maps-embed'
    },
    instagram: {
      "class": 'instagram-embed'
    },
    platformsList: {
      "class": 'platforms-list-embed'
    },
    soundcloud: {
      "class": 'soundcloud-embed'
    },
    spotim: {
      "class": 'spotim-embed'
    },
    spotify: {
      "class": 'spotify-embed'
    },
    storyList: {
      "class": 'story-list'
    },
    tagboard: {
      "class": 'tagboard-embed'
    },
    tiktok: {
      "class": 'tiktok-embed'
    },
    twitter: {
      "class": 'twitter-embed'
    },
    vimeo: {
      "class": 'vimeo-embed'
    },
    youtube: {
      "class": 'youtube-embed'
    }
  },
  list: {
    "class": 'list'
  },
  paragraph: {
    "class": 'block'
  },
  quote: {
    "class": 'left'
  },
  tagboard: {
    "class": 'tagboard-embed'
  },
  tweet: {
    "class": 'twitter-tweet'
  },
  video: {
    "class": 'article-body-video'
  }
};
exports["default"] = _default;